import { useStyletron } from 'baseui';
import _get from 'lodash/get';
import _isFunction from 'lodash/isFunction';

import { KEY_VALUE_LAYOUT } from './constant';
import { KeyValueLayout, StyleOverrideObjectT, StyleOverrideFunctionT } from './types';

interface UseStylesProps {
	keyValueLayout: KeyValueLayout | undefined;
	styleOverride: StyleOverrideObjectT | StyleOverrideFunctionT;
	keyData: any;
}
const useStyles = ({ keyValueLayout, styleOverride, keyData }: UseStylesProps) => {
	const [css] = useStyletron();

	const overriddenStyles = _isFunction(styleOverride) ? styleOverride({ keyData }) : styleOverride;
	const keyStyles = _get(overriddenStyles, 'key', '');
	const valueStyles = _get(overriddenStyles, 'value', '');

	const commonLayoutClasses = {
		listFilterContainer: css({
			display: 'flex',
			flexDirection: 'column',
			gap: '20px'
		}),
		labelWithFilter: css({ display: 'flex', justifyContent: 'space-between', minWidth: '500px' }),
		labelText: css({ fontWeight: 'bold', padding: '12px 0px' }),
		jsonTextWrapper: css({ display: 'flex', flexDirection: 'column', gap: '5px' }),
		jsonTextPairWrapper: css({ display: 'flex', justifyContent: 'space-between' }),
		documentImage: css({
			height: '200px'
		}),
		valueContainer: css({
			display: 'flex',
			flexDirection: 'row',
			justifyContent: 'center',
			alignItems: 'center',
			gap: '10px'
		})
	};

	const copyToClipboardClasses = {
		ctcImage: css({
			width: '20px',
			height: '20px'
		}),
		ctcText: css({
			paddingLeft: '10px'
		})
	};

	const layoutClasses = {
		[KEY_VALUE_LAYOUT.HORIZONTAL]: {
			keyValueRow: css({
				display: 'flex',
				flexDirection: 'column',
				backgroundColor: '#eeeeee',
				gap: '20px',
				padding: '10px 10px',
				justifyContent: 'center',
				alignItems: 'center',
				margin: '5px',
				minWidth: '400px'
			}),
			key: [css({ textAlign: 'left', color: 'grey' }), keyStyles].join(' '),
			value: [css({ textAlign: 'left' }), valueStyles].join(' '),
			keyValueList: css({
				display: 'flex',
				flexFlow: 'row wrap',
				height: '100%',
				backgroundColor: '#ffffff',
				gap: '10px 10px'
			})
		},
		[KEY_VALUE_LAYOUT.VERTICAL]: {
			keyValueRow: css({ display: 'flex', gap: '100px', padding: '16px 20px', backgroundColor: '#ffffff' }),
			key: [css({ textAlign: 'left', width: '250px' }), keyStyles].join(' '),
			value: [css({ textAlign: 'left', width: '250px' }), valueStyles].join(' '),
			keyValueList: css({
				display: 'flex',
				flexDirection: 'column',
				backgroundColor: '#ffffff'
			})
		}
	};
	return {
		..._get(layoutClasses, [keyValueLayout || KEY_VALUE_LAYOUT.VERTICAL]),
		...commonLayoutClasses,
		...copyToClipboardClasses
	};
};

export default useStyles;
